export interface GeoLocation {
	latitude?: number;
	longitude?: number;
	city?: string;
	district?: string;
	country?: string;
}

export enum GmailLoginType {
	Success = 'login_success',
	Failure = 'login_failure',
}

export interface GmailUserLogin {
	id: string;
	gmailUserId: string;
	time: Date;
	eventType: GmailLoginType;
	ipAddress: string;
	onSite: boolean;
	location: GeoLocation;
}

export interface GmailUserDevice {
	id: string;
	deviceId: string;
	osVersion: string;
	deviceModel: string;
	deviceType: string;
	createdOn: Date;
	lastSync: Date;
}

export interface GmailUser {
	id: string;
	email: string;
	fullName: string;
	isAdmin: boolean;
	firestoreDeviceIds: string[];
}

export interface GeolocationAPIResponse {
	ip: string,
	location: {
		continent_code: string,
		continent_name: string,
		country_code2: string,
		country_code3: string,
		country_name: string,
		country_name_official: string,
		country_capital: string,
		state_prov: string,
		state_code: string,
		district: string,
		city: string,
		zipcode: string,
		latitude: string,
		longitude: string,
		is_eu: boolean,
		country_flag: string,
		geoname_id: string,
		country_emoji: string
	},
	country_metadata: {
		calling_code: string,
		tld: string,
		languages: string[]
	},
	currency: {
		code: string,
		name: string,
		symbol: string
	}
}